import React from 'react';
import {Box,Stack,Link} from '@mui/material'
import { useSearchParams } from "react-router-dom";


function Footer() {

    const [searchParams] = useSearchParams();

    let queryString = searchParams.toString()
    if(queryString?.length > 0){
        queryString = `?${queryString}`;
    }

    const style_menu={
        //textDecoration:"none",
        fontSize:15,
        color:"#393939",
    }

   

    return (
        <Box component="footer" bgcolor="#0a174b" color="white" p={2}>
           
            <Box textAlign="center" mt={1}>© 2024 Arinco</Box>
            
        </Box>
    );
}

export default Footer;